import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Overlay from 'components/Overlay/Overlay';
import SearchUnitHeader from 'components/SearchUnitHeader/SearchUnitHeader';
import SearchUnitRooms from 'components/SearchUnitRooms/SearchUnitRooms';
import SearchUnitDestinationLayout from 'layouts/SearchUnitDestinationLayout/SearchUnitDestinationLayout';
import SearchUnitDurationLayout from 'layouts/SearchUnitDurationLayout/SearchUnitDurationLayout';
import SearchUnitDepartureAirportLayout from 'layouts/SearchUnitDepartureAirportLayout/SearchUnitDepartureAirportLayout';
import SearchUnitDepartureDateLayout from 'layouts/SearchUnitDepartureDateLayout/SearchUnitDepartureDateLayout';
import LinkButton from 'components/LinkButton/LinkButton';
import * as searchUnitActions from 'actions/searchUnitActions';

import * as optimizelyUtil from 'utils/optimizely';
import calendarUtils from 'utils/calendar';
import dates from 'utils/dates';
import { dayInMilliseconds } from 'utils/utils';
import { MONTH_FLEXIBILITY_VALUE } from 'constants/searchUnit';

import './SearchUnitStandaloneLayout.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  baseState: state.baseState,
  loadingState: state.appState.get('loadingState'),
  searchWholeMonthCalendar: state.featureFlags.get('SearchWholeMonthCalendar'),
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    searchUnitActionsBound: bindActionCreators(searchUnitActions, dispatch),
  };
}

export class SearchUnitStandaloneLayout extends PureComponent {
  static propTypes = {
    baseState: ImmutablePropTypes.map,
    loadingState: PropTypes.string,
    location: PropTypes.object.isRequired,
    searchUnitActionsBound: PropTypes.object.isRequired,
    searchWholeMonthCalendar: PropTypes.bool,
  };

  static defaultProps = {
    baseState: Immutable.Map(),
    loadingState: '',
    searchWholeMonthCalendar: false,
  };

  componentDidMount() {
    const { searchUnitActionsBound, location } = this.props;
    searchUnitActionsBound.getSearchUnitData(location.query.state);
  }

  get isEverywhereSelected() {
    const { baseState } = this.props;
    const selectedDestinations = baseState.get('D_Destination', Immutable.List());
    const everywhereDimVal = 214;

    return selectedDestinations.first() === everywhereDimVal;
  }

  get isWholeMonthSelected() {
    const { baseState, searchWholeMonthCalendar } = this.props;
    const flexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
    const isWholeMonthFlexibility = flexibility === MONTH_FLEXIBILITY_VALUE;
    const departureDateTimestamp = calendarUtils.getDepartureDate(baseState, false) * dayInMilliseconds;
    const isDepartureFirstDayOfMonth = dates.format(departureDateTimestamp, 'DD') === '01';

    return searchWholeMonthCalendar && isWholeMonthFlexibility && isDepartureFirstDayOfMonth;
  }

  resetSearchForm = () => {
    const { searchUnitActionsBound } = this.props;

    searchUnitActionsBound.resetSearchForm();
  }

  onSearchClick = () => {
    if (this.isEverywhereSelected) {
      optimizelyUtil.fireEvent('SearchSubmitWithEverywhere', 'clicked');
    }
    if (this.isWholeMonthSelected) {
      optimizelyUtil.fireEvent('SearchByMonth', 'clicked');
    }
  }

  render() {
    const { baseState, loadingState, searchUnitActionsBound, searchWholeMonthCalendar } = this.props;

    return (
      <div className="search-unit-standalone-layout">
        {loadingState && <Overlay loadingState={loadingState} />}
        <SearchUnitHeader resetSearchForm={this.resetSearchForm} />
        <div className="search-unit-standalone-layout__inner">
          <div className="search-unit-standalone-layout__destination">
            <div className="search-unit-standalone-layout__destination__inner">
              <SearchUnitDestinationLayout />
            </div>
          </div>
          <div className="search-unit-standalone-layout__dept-airport">
            <SearchUnitDepartureAirportLayout />
          </div>
          <div className="search-unit-standalone-layout__dept-date">
            <SearchUnitDepartureDateLayout
              isWholeMonthCalendarEnabled={searchWholeMonthCalendar}
            />
          </div>
          <div className="search-unit-standalone-layout__duration">
            <SearchUnitDurationLayout />
          </div>
          <div className="search-unit-standalone-layout__rooms">
            <SearchUnitRooms
              baseState={baseState}
              searchUnitActionsBound={searchUnitActionsBound}
            />
          </div>
          <div className="search-unit-standalone-layout__cta">
            <div className="search-unit-standalone-layout__cta__inner">
              <LinkButton type="chevrons-on-left" align="left" isExternal to={`/holidays/?state=${baseState.get('currentStateEncoded')}`} onClick={this.onSearchClick}>
                  Search
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchUnitStandaloneLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/SearchUnitStandaloneLayout/SearchUnitStandaloneLayout.jsx
 **/